(function () {
  function initRankedCards(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ranked-card]').forEach(function (card) {
      if (card.getAttribute('data-ranked-card-ready') === 'true') return;
      card.setAttribute('data-ranked-card-ready', 'true');

      var dots = card.querySelectorAll('.ranked-card__dot');
      var slides = card.querySelectorAll('.ranked-card__slide');
      if (!dots.length || !slides.length) return;

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = parseInt(dot.getAttribute('data-slide-target'), 10);
          dots.forEach(function (item) { item.classList.remove('is-active'); });
          slides.forEach(function (item) { item.classList.remove('is-active'); });
          dot.classList.add('is-active');

          var slide = card.querySelector('[data-slide-index="' + target + '"]');
          if (slide) slide.classList.add('is-active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRankedCards(document);
    });
  } else {
    initRankedCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRankedCards(event.target);
  });
})();
